import {
  createReducer,
  keyValueSetReducer,
  keyValueUpdateReducer,
} from '../../redux/helpers/redux-helpers'
import { FsCore } from '../../types/fs-core'
import { setCalculator, useCalculator, UseCalculatorPayload } from './calculators-actions'

export const calculatorsReducer = createReducer<FsCore.ESCalculatorsState>(
  {
    [setCalculator]: (state, { id, calculator }) => keyValueSetReducer(state, id, calculator),
    [useCalculator]: (state, { calculatorId, usedById }: UseCalculatorPayload) => {
      const calculator = state[calculatorId]
      if (!calculator) return state
      const usedBy = [...calculator.usedBy]
      if (usedBy.indexOf(usedById) === -1) {
        usedBy.push(usedById)
      }
      return keyValueUpdateReducer(state, calculatorId, {
        usedBy,
      })
    },
  },
  {},
)
